module.exports = __webpack_public_path__ + "static/media/fly0203.9acd9a42.webp";